import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useCategories } from "../hooks";
import { Loading } from "../../../components";

interface ICategoryInput {
  form: UseFormReturn<any, any>;
  error?: string;
}

export const CategoryInput: React.FC<ICategoryInput> = ({ form }) => {
  const { data, loading } = useCategories();

  const categoryId = form.watch("categoryId");

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="flex flex-col">
      <label className="label">Catégories</label>
      <select
        className="input appearance-none w-full"
        {...form.register("categoryId")}
      >
        {data?.categories?.results?.map((category) => (
          <option value={category.id} selected={categoryId === category.id}>
            {category.name}
          </option>
        ))}
      </select>
    </div>
  );
};
